// @ts-ignore
import type {IOrderFalseRoundTripState} from "@/store/states/IOrderFalseRoundTripState.interface";

const orderFalseRoundTrip = {
    prefix: 'falseRound.',
    namespaced: true,
    state: <IOrderFalseRoundTripState>{
        ids: null,
        isTransportationFormValid: true,
        pickUp: {
            id: null,
            city: null,
            address: null,
            address_to_show: null
        },
        dropOff: {
            id: null,
            city: null,
            address: null,
            address_to_show: null
        },
        tripDepartureDate: null,
        tripPassengers: 1,
        transportations: null,
        transportationId: null,
        pickup_specified_address: "",
        dropoff_specified_address: "",
        pickup_note: "",
        dropoff_note: "",
    },
    mutations: {
        SET_TRANSPORTATION_FORM_VALID(state, payload: boolean): void {
            state.isTransportationFormValid = payload;
        },

        SET_STATE_PROP_VALUE(state: IOrderFalseRoundTripState, payload: {prop: string, value: any}[]): void {

            for (const obj of payload) {
                if (! state.hasOwnProperty(obj.prop)) {
                    console.error('Trying to set state prop that doesn\'t exist');
                    return;
                }
            }

            for (const obj of payload) {
                const prop = obj.prop;
                let value = obj.value;

                switch (prop) {
                    case 'tripDepartureDate':
                        if (typeof value !== 'object') {
                            // @ts-ignore
                            value = new Date(value);
                        }
                        break;
                }

                state[prop] = value;

                if(prop === 'transportations') {
                    continue;
                }

                localStorage.removeItem(orderFalseRoundTrip.prefix + prop);

                if (value !== undefined) {
                    localStorage.setItem(orderFalseRoundTrip.prefix + prop, value ? JSON.stringify(value) : value);
                }
            }
        },

        INITIALIZE_FALSE_ROUND_TRIP_STATE(state: IOrderFalseRoundTripState): void {
            state['defaultState'] = {...state};

            for (const prop of Object.getOwnPropertyNames(state)) {

                let value = localStorage.getItem(orderFalseRoundTrip.prefix + prop);

                if (value) {
                    value = JSON.parse(value);

                    switch (prop) {
                        case 'tripDepartureDate':
                            // @ts-ignore
                            value = new Date(value);
                            break;
                    }

                    state[prop] = value;
                }
            }
        },

        CLEAR_STATE(state: IOrderFalseRoundTripState): void {
            for (const prop of Object.getOwnPropertyNames(state)) {
                localStorage.removeItem(orderFalseRoundTrip.prefix + prop);

                if (state.defaultState) {
                    state[prop] = state.defaultState[prop];
                }
            }
        }
    },

    actions: {
        updateState(context, data: {prop: string, value: any}[]): void {
            context.commit('SET_STATE_PROP_VALUE', data);
        },
    },
    getters: {

    }
}

export default orderFalseRoundTrip;